import axios from 'axios';

const BASE_URL = `${import.meta.env.VITE_APP_NEXT_API_URL}/v1/customers`;

// eslint-disable-next-line import/prefer-default-export
export const Authenticate = async (sessionId) => {
  const localAxios = axios.create();
  return localAxios({
    method: 'POST',
    data: {
      sessionId,
    },
    url: `${BASE_URL}/authenticate-me`,
  });
};
